import Vue from "vue";

import { LazyPicture } from "./scripts/components/lazy-picture";
import { Carousel } from "./scripts/components/newCarousel";

import "./styles/storyShell.css";
import "./styles/story/article.css";
import "./styles/story/carousel.css";
import "./styles/story/lazy-picture.css";

const vm = new Vue({});

Vue.component("lazy-picture", LazyPicture);
Vue.component("multi-carousel", Carousel);

vm.$mount("#view");



// WEBPACK FOOTER //
// ./src/story.ts